import { render, staticRenderFns } from "./withdrawDeposit.vue?vue&type=template&id=8c22b122&scoped=true&"
import script from "./withdrawDeposit.vue?vue&type=script&lang=js&"
export * from "./withdrawDeposit.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDeposit.vue?vue&type=style&index=0&id=8c22b122&lang=scss&scoped=true&"
import style1 from "./withdrawDeposit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c22b122",
  null
  
)

export default component.exports